// Tenant-specific routes
import React from 'react';
const TenantDashboard = React.lazy(() => import('@/pages/inside/tenant/Dashboard'));
const Projects = React.lazy(() => import('@/pages/inside/modules/projects/directory/screen/Directory'));
const ProjectsOverview = React.lazy(() => import('@/pages/inside/modules/projects/overview/screen/Overview'));
const ProjectDetail = React.lazy(() => import('@/pages/inside/modules/projects/detail/screen/ProjectDetail'));
const Roles = React.lazy(() => import('@/pages/inside/tenant/Roles'));
const Users = React.lazy(() => import('@/pages/inside/tenant/Users'));
const Directory = React.lazy(() => import('@/pages/inside/modules/hr/directory/screen/Directory'));
const Overview = React.lazy(() => import('@/pages/inside/modules/hr/overview/screen/Overview'));
const Employees = React.lazy(() => import('@/pages/inside/modules/hr/employee/screen/Employee'));
const Leave = React.lazy(() => import('@/pages/inside/modules/hr/leave/screen/Leave'));
const Request = React.lazy(() => import('@/pages/inside/modules/hr/request/screen/Request'));
const Attendance = React.lazy(() => import('@/pages/inside/modules/hr/attendance/screen/Attendance'));
const ProfileDetail = React.lazy(() => import('@/pages/inside/modules/hr/profile/screen/ProfileDetail'));
const Performance = React.lazy(() => import('@/pages/inside/modules/hr/performance/screen/Performance'));
const RemovalRequests = React.lazy(() => import('@/pages/inside/tenant/RemovalRequests'));
const OpenMarket = React.lazy(() => import('@/pages/inside/tenant/OpenMarket'));
const OpenMarketProjectRequests = React.lazy(() => import('@/pages/inside/tenant/OpenMarketProjectRequests'));
const Sales = React.lazy(() => import('@/pages/inside/tenant/Sales'));
const Billing = React.lazy(() => import('@/pages/inside/tenant/Billing'));
const Notifications = React.lazy(() => import('@/pages/inside/tenant/Notifications'));
const Settings = React.lazy(() => import('@/pages/inside/tenant/Settings'));
const Permissions = React.lazy(() => import('@/pages/inside/tenant/Permissions'));
const Chat = React.lazy(() => import('@/pages/inside/tenant/Chat'));
const Profile = React.lazy(() => import('@/pages/inside/tenant/Profile'));
const Clients = React.lazy(() => import('@/pages/inside/tenant/Clients'));
const AssetsManager = React.lazy(() => import('@/pages/inside/tenant/AssetsManager'));
const ProjectTemplates = React.lazy(() => import('@/pages/inside/tenant/ProjectTemplates'));
const Schedules = React.lazy(() => import('@/pages/inside/modules/hr/schedule/screen/Schedule'));
const SalaryDistribution = React.lazy(() => import('@/pages/inside/modules/hr/salary/screen/SalaryDistribution'));
const BugReports = React.lazy(() => import('@/pages/inside/tenant/BugReports'));
const PMODashboard = React.lazy(() => import('@/pages/inside/modules/projects/pmo_dashboard/screen/PMODashboard'));
const Sprints = React.lazy(() => import('@/pages/inside/modules/projects/sprints/screen/Sprints'));
const Kanban = React.lazy(() => import('@/pages/inside/modules/projects/kanban/screen/Kanban'));
const BuildScreen = React.lazy(() => import('@/pages/inside/modules/projects/builds/screen/BuildScreen'));

export const tenantRoutes = [
    {
        path: '/dashboard',
        component: TenantDashboard,
        menuItem: { key: '/dashboard', label: 'Dashboard' },
    },
    {
        path: '/tenant/dashboard',
        component: TenantDashboard,
        menuItem: { key: '/tenant/dashboard', label: 'Dashboard' },
    },
    {
        path: '/reports',
        component: BugReports,
        menuItem: { key: '/reports', label: 'Bug Reports' },
    },
    {
        path: '/tenant/reports',
        component: BugReports,
        menuItem: { key: '/tenant/reports', label: 'Bug Reports' },
    },
    {
        path: '/projects',
        component: ProjectsOverview,
        menuItem: { key: '/projects', label: 'Projects' },
        requiredPermission: null,
    },
    {
        path: '/tenant/projects',
        component: ProjectsOverview,
        requiredPermission: null,
    },
    {
        path: '/projects/overview',
        component: ProjectsOverview,
        requiredPermission: null,
    },
    {
        path: '/tenant/projects/overview',
        component: ProjectsOverview,
        requiredPermission: null,
    },
    {
        path: '/projects/directory',
        component: Projects,
        requiredPermission: null,
    },
    {
        path: '/tenant/projects/directory',
        component: Projects,
        requiredPermission: null,
    },
    {
        path: '/projects/sprints',
        component: Sprints,
        requiredPermission: null,
    },
    {
        path: '/tenant/projects/sprints',
        component: Sprints,
        requiredPermission: null,
    },
    {
        path: '/projects/tasks',
        component: Sprints,
        requiredPermission: null,
    },
    {
        path: '/tenant/projects/tasks',
        component: Sprints,
        requiredPermission: null,
    },
    {
        path: '/projects/kanban',
        component: Kanban,
        requiredPermission: null,
    },
    {
        path: '/tenant/projects/kanban',
        component: Kanban,
        requiredPermission: null,
    },
    {
        path: '/projects/build',
        component: BuildScreen,
        requiredPermission: ['projects.builds.view', 'projects.builds.view_all'],
    },
    {
        path: '/tenant/projects/build',
        component: BuildScreen,
        requiredPermission: ['projects.builds.view', 'projects.builds.view_all'],
    },
    {
        path: '/projects/release',
        component: PMODashboard,
        requiredPermission: null,
    },
    {
        path: '/tenant/projects/release',
        component: PMODashboard,
        requiredPermission: null,
    },
    {
        path: '/projects/submit-to-client',
        component: PMODashboard,
        requiredPermission: null,
    },
    {
        path: '/tenant/projects/submit-to-client',
        component: PMODashboard,
        requiredPermission: null,
    },
    {
        path: '/projects/:projectId',
        component: ProjectDetail,
        requiredPermission: null,
    },
    {
        path: '/tenant/projects/:projectId',
        component: ProjectDetail,
        requiredPermission: null,
    },
    {
        path: '/projects/:projectId/detail',
        component: ProjectDetail,
        requiredPermission: null,
    },
    {
        path: '/tenant/projects/:projectId/detail',
        component: ProjectDetail,
        requiredPermission: null,
    },
    {
        path: '/clients',
        component: Clients,
        requireAbility: ['clients.clients.view'],
    },
    {
        path: '/tenant/clients',
        component: Clients,
        requireAbility: ['clients.clients.view'],
    },
    {
        path: '/clients/inhouse',
        component: Clients,
        requireAbility: ['clients.clients.view'],
    },
    {
        path: '/tenant/clients/inhouse',
        component: Clients,
        requireAbility: ['clients.clients.view'],
    },
    {
        path: '/roles',
        component: Roles,
        menuItem: { key: '/roles', label: 'Overview' },
        requiredPermission: 'saas.roles.view',
    },
    {
        path: '/tenant/roles',
        component: Roles,
        requiredPermission: 'saas.roles.view',
    },
    {
        path: '/users',
        component: Users,
        menuItem: { key: '/users', label: 'Overview' },
        requiredPermission: 'saas.users.view',
    },
    {
        path: '/tenant/users',
        component: Users,
        requiredPermission: 'saas.users.view',
    },
    {
        path: '/hr/overview',
        component: Overview,
        menuItem: { key: '/hr/overview', label: 'Overview' },
        requiredPermission: 'hr.employees.view',
    },
    {
        path: '/tenant/hr/overview',
        component: Overview,
        requiredPermission: 'hr.employees.view',
    },
    {
        path: '/hr/directory',
        component: Directory,
        requiredPermission: 'hr.employees.view',
    },
    {
        path: '/tenant/hr/directory',
        component: Directory,
        requiredPermission: 'hr.employees.view',
    },
    {
        path: '/hr/employees',
        component: Employees,
        menuItem: { key: '/hr/employees', label: 'Employees' },
        requiredPermission: 'hr.employees.view',
    },
    {
        path: '/tenant/hr/employees',
        component: Employees,
        requiredPermission: 'hr.employees.view',
    },
    {
        path: '/hr/schedules',
        component: Schedules,
        menuItem: { key: '/hr/schedules', label: 'Schedules' },
        requiredPermission: 'hr.schedule.view',
    },
    {
        path: '/tenant/hr/schedules',
        component: Schedules,
        requiredPermission: 'hr.schedule.view',
    },
    {
        path: '/hr/leave',
        component: Leave,
        menuItem: { key: '/hr/leave', label: 'Leave' },
        requireAbility: ['hr.leave.view', 'hr.leaves.view'],
    },
    {
        path: '/tenant/hr/leave',
        component: Leave,
        requireAbility: ['hr.leave.view', 'hr.leaves.view'],
    },
    {
        path: '/hr/request',
        component: Request,
        menuItem: { key: '/hr/request', label: 'Requests' },
        requireAbility: ['hr.request.view', 'hr.request.view_all', 'hr.request.create'],
    },
    {
        path: '/tenant/hr/request',
        component: Request,
        requireAbility: ['hr.request.view', 'hr.request.view_all', 'hr.request.create'],
    },
    {
        path: '/hr/attendance',
        component: Attendance,
        menuItem: { key: '/hr/attendance', label: 'Attendance' },
        requiredPermission: 'hr.attendance.view',
    },
    {
        path: '/tenant/hr/attendance',
        component: Attendance,
        requiredPermission: 'hr.attendance.view',
    },
    {
        path: '/hr/profile/detail',
        component: ProfileDetail,
        requiredPermission: null,
    },
    {
        path: '/tenant/hr/profile/detail',
        component: ProfileDetail,
        requiredPermission: null,
    },
    {
        path: '/hr/attendance/detail',
        component: ProfileDetail,
        requiredPermission: null,
    },
    {
        path: '/tenant/hr/attendance/detail',
        component: ProfileDetail,
        requiredPermission: null,
    },
    {
        path: '/hr/performance',
        component: Performance,
        menuItem: { key: '/hr/performance', label: 'Performance' },
        requiredPermission: 'hr.performance.view',
    },
    {
        path: '/tenant/hr/performance',
        component: Performance,
        requiredPermission: 'hr.performance.view',
    },
    {
        path: '/hr/salary',
        component: SalaryDistribution,
        menuItem: { key: '/hr/salary', label: 'Salary' },
        requireAbility: ['hr.salary.view'],
    },
    {
        path: '/tenant/hr/salary',
        component: SalaryDistribution,
        requireAbility: ['hr.salary.view'],
    },
    {
        path: '/hr/removal-requests',
        component: RemovalRequests,
        menuItem: { key: '/hr/removal-requests', label: 'Removal Requests' },
        requiredPermission: 'hr.employees.view',
    },
    {
        path: '/tenant/hr/removal-requests',
        component: RemovalRequests,
        requiredPermission: 'hr.employees.view',
    },
    {
        path: '/open-market/overview',
        component: OpenMarket,
        menuItem: { key: '/open-market/overview', label: 'Overview' },
        requiredPermission: null,
    },
    {
        path: '/tenant/open-market/overview',
        component: OpenMarket,
        requiredPermission: null,
    },
    {
        path: '/open-market/project-requests',
        component: OpenMarketProjectRequests,
        requiredPermission: 'project_requests.requests.view',
    },
    {
        path: '/tenant/open-market/project-requests',
        component: OpenMarketProjectRequests,
        requiredPermission: 'project_requests.requests.view',
    },
    {
        path: '/sales/leads',
        component: Sales,
        menuItem: { key: '/sales/leads', label: 'Leads' },
        requiredPermission: 'sales.leads.view',
    },
    {
        path: '/tenant/sales/leads',
        component: Sales,
        requiredPermission: 'sales.leads.view',
    },
    {
        path: '/billing/requests',
        component: Billing,
        menuItem: { key: '/billing/requests', label: 'Requests' },
        requiredPermission: 'billing.requests.view',
    },
    {
        path: '/tenant/billing/requests',
        component: Billing,
        requiredPermission: 'billing.requests.view',
    },
    {
        path: '/notifications',
        component: Notifications,
        requiredPermission: null,
    },
    {
        path: '/tenant/notifications',
        component: Notifications,
        requiredPermission: null,
    },
    {
        path: '/notifications/unread',
        component: Notifications,
        requiredPermission: null,
    },
    {
        path: '/tenant/notifications/unread',
        component: Notifications,
        requiredPermission: null,
    },
    {
        path: '/notifications/read',
        component: Notifications,
        requiredPermission: null,
    },
    {
        path: '/tenant/notifications/read',
        component: Notifications,
        requiredPermission: null,
    },
    {
        path: '/permissions',
        component: Permissions,
        menuItem: { key: '/permissions', label: 'Permission Management' },
        requiredPermission: 'saas.roles.view',
    },
    {
        path: '/tenant/permissions',
        component: Permissions,
        requiredPermission: 'saas.roles.view',
    },
    {
        path: '/chat/:chatId',
        component: Chat,
        requiredPermission: 'chat.chats.view',
    },
    {
        path: '/tenant/chat/:chatId',
        component: Chat,
        requiredPermission: 'chat.chats.view',
    },
    {
        path: '/chat',
        component: Chat,
        menuItem: { key: '/chat', label: 'Chat' },
        requiredPermission: 'chat.chats.view',
    },
    {
        path: '/tenant/chat',
        component: Chat,
        requiredPermission: 'chat.chats.view',
    },
    {
        path: '/profile',
        component: Profile,
        menuItem: { key: '/profile', label: 'Profile' },
    },
    {
        path: '/tenant/profile',
        component: Profile,
    },
    {
        path: '/settings',
        component: Settings,
        menuItem: { key: '/settings', label: 'Settings' },
    },
    {
        path: '/tenant/settings',
        component: Settings,
    },
    {
        path: '/settings/origins',
        component: Settings,
    },
    {
        path: '/tenant/settings/origins',
        component: Settings,
    },
    {
        path: '/assets-manager',
        component: AssetsManager,
        requiredPermission: null,
    },
    {
        path: '/tenant/assets-manager',
        component: AssetsManager,
        requiredPermission: null,
    },
    {
        path: '/project-templates',
        component: ProjectTemplates,
        menuItem: { key: '/project-templates', label: 'Project Templates' },
        requiredPermission: null,
    },
    {
        path: '/tenant/project-templates',
        component: ProjectTemplates,
        requiredPermission: null,
    },
];
